export const hand1Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [50, 0],
    x: [-50, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.6,
    },
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 50],
    x: [0, -50],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.8,
    },
  },
};

export const star1Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [100, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.9,
    },
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 100],
    transition: {
      duration: 0.4,
      ease: 'easeInOut',
      delay: 0.8,
    },
  },
};

export const star2Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [10, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 1,
    },
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 30],
    transition: {
      duration: 0.4,
      ease: 'easeInOut',
      delay: 0.7,
    },
  },
};

export const hand2Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [40, 0],
    x: [-40, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.7,
    },
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 40],
    x: [0, -40],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.9,
    },
  },
};

export const hand3Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [40, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.8,
    },
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 40],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 1,
    },
  },
};

export const hand4Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [50, 0],
    x: [50, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.7,
    },
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 50],
    x: [0, 50],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.7,
    },
  },
};

export const hand5Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [50, 0],
    x: [50, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.7,
    },
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 50],
    x: [0, 50],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.8,
    },
  },
};

export const welcomeMessageVariants = {
  welcomeExit: {
    opacity: [1, 0],
    transitionEnd: { display: 'none' },
    transition: { delay: 1, duration: 0.5 },
  },
};

export const welcomeTitleVariants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [100, 0],
    transition: {
      duration: 0.8,
      ease: 'easeInOut',
    },
  },
};

export const landingVariants = {
  welcomeEnter: {
    opacity: 0,
    transition: { duration: 0 },
  },
  welcomeExit: {
    opacity: 0,
    transition: { duration: 0 },
  },
  landingEnter: {
    opacity: [0, 1],
    y: [100, 0],
    transition: {
      duration: 0.8,
      ease: 'easeInOut',
    },
  },
};
